/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RoledataaccessRa } from '../../models/roledataaccess-ra';

export interface GetRoleDataAccess$Params {
  arid: number;
}

export function getRoleDataAccess(http: HttpClient, rootUrl: string, params: GetRoleDataAccess$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RoledataaccessRa>>> {
  const rb = new RequestBuilder(rootUrl, getRoleDataAccess.PATH, 'get');
  if (params) {
    rb.path('arid', params.arid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RoledataaccessRa>>;
    })
  );
}

getRoleDataAccess.PATH = '/api/AclRole/roleData/{arid}';
